var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOnboardBackgroundDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.08,
    y1: 0.258,
    x2: 0.946,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#121314"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#121314",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.08,
    y1: 0.258,
    x2: 0.946,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fa9c2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fa9c2b",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.08,
    y1: 0.258,
    x2: 0.946,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fa9c2b",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fa9c2b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Background_Image",
    "data-name": "Background Image",
    transform: "translate(7093.777 7386.037)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7491",
    "data-name": "Rectangle 7491",
    width: 1920,
    height: 1080,
    transform: "translate(-7093.777 -7386.037)",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersection_1",
    "data-name": "Intersection 1",
    d: "M1047.189,921a466.745,466.745,0,0,0,53.794-218.238c0-258.874-209.847-468.733-468.707-468.733S163.568,443.888,163.568,702.762A466.744,466.744,0,0,0,217.363,921H0V396.2C114.065,161.868,354.624,0,632.276,0,1019.759,0,1335,315.258,1335,702.762A700.028,700.028,0,0,1,1300.322,921Z",
    transform: "translate(-7093.777 -7227.037)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersection_4",
    "data-name": "Intersection 4",
    d: "M183.144,953C70.774,853.109,0,707.5,0,545.343,0,244.158,244.218,0,545.477,0A542.991,542.991,0,0,1,849,92.154v266.5C786.165,256.916,673.609,188.98,545.477,188.98c-196.548,0-356.451,159.863-356.451,356.363S348.929,901.7,545.477,901.7c128.132,0,240.688-67.936,303.523-169.677V953Z",
    transform: "translate(-6022.777 -7259.037)",
    opacity: 0.05,
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersection_3",
    "data-name": "Intersection 3",
    d: "M0,478.91V13.543Q3.23,6.725,6.649,0H236.192a354.454,354.454,0,0,0-99.261,246.227c0,196.294,159.928,355.99,356.506,355.99s356.506-159.7,356.506-355.99A354.455,354.455,0,0,0,750.682,0H980.226A541.882,541.882,0,0,1,1039,246.227C1039,547.1,794.743,791,493.437,791,275.494,791,87.4,663.386,0,478.91Z",
    transform: "translate(-7093.777 -7386.037)",
    opacity: 0.05,
    fill: "url(#linear-gradient-3)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardBackgroundDark);
export default __webpack_public_path__ + "static/media/onboard_background_dark.0321adfaaaa73d039ddea05c6deb5b61.svg";
export { ForwardRef as ReactComponent };